const platform = import.meta.env.VITE_MINI_APP_PLATFORM;

/** True when running inside the Super QI mini-app host. */
export const isSuperQi = (): boolean => platform === 'SUPER_QI';

/** True when running inside any host-controlled mini-app (Super QI or QI Services). */
export const isMiniApp = (): boolean => platform === 'SUPER_QI' || platform === 'QI_SERVICES';
